export const PUBLIC_ROUTES = [
  "index",
  "logout",
  "test-links",
  "login-index",
  "login-njorda-admin",
  "onboarding-register",
  "onboarding-organization-verification",
  "onboarding-select-subscription",
  "onboarding-confirm-subscription",
];
